import React from "react";
import Cookies from "universal-cookie";
import { Table } from "reactstrap";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { Document, Page, View, Text, Image, pdf } from "@react-pdf/renderer";
import Logo from "../imagenes/escudoIseP.png";
import comprueboPermisos from '../tools/comprueboPermisos.js';
import seteaCokieExpediente from "./seteaCokieExpediente";
import devuelveDependenciaConstultada from "../tools/devuelveDependencia";
import regresaBienFechaYHora from "../tools/regresaBienFechayDia";
import devuelveSede from "../tools/devuelveSede";
import seteaCokieReciboExpediente from "./seteaCokieReciboExpediente";
import devuelvemeElUsuario from "../Expedientes/devuelveUsuario";
import obtieneDatos from '../tools/obtieneDatosCookiesUsuario';
const URL_BASE_ARCHIVOS = "https://wwwa.isepsantafe.net.ar";
const URL_UNIR_PDFS = "https://wwwp.isepsantafe.net.ar/expedientes/unir-sin-firmas-pro";

function ModuloDevuelveListaMov(props) {
  const cookies = new Cookies();
  const Usuario = obtieneDatos();
  const [modalOpen, setModalOpen] = React.useState(false);
  const [movimientoSeleccionado, setMovimientoSeleccionado] = React.useState(null);
  const [modalTimelineOpen, setModalTimelineOpen] = React.useState(false);
  const [timeline, setTimeline] = React.useState([]);
  const [mostrarPreview, setMostrarPreview] = React.useState(true);
  const [filtroDependencia, setFiltroDependencia] = React.useState("");
  const [filtroFecha, setFiltroFecha] = React.useState("");

  // PDF seleccionados, en el orden en que serán unidos.
  const [pdfsSeleccionados, setPdfsSeleccionados] = React.useState([]);
  const [uniendoPdfs, setUniendoPdfs] = React.useState(false);

  const obtenerIdRecibo = React.useCallback((movimiento) => `recibo-${movimiento?.id || movimiento?.expedienteID || movimiento?.fechaEntrada}`, []);

  const dependenciasMap = React.useMemo(() => {
    const mapa = {};
    devuelveDependenciaConstultada().forEach((dep) => {
      mapa[dep.id] = dep.descripcion;
    });
    return mapa;
  }, []);

  const sedesMap = React.useMemo(() => {
    const mapa = {};
    devuelveSede().forEach((sede) => {
      mapa[sede.id] = sede.descripcion;
    });
    return mapa;
  }, []);

  const obtenerUrlCompleta = React.useCallback((url) => {
    if (!url) return "";
    if (String(url).startsWith("http://") || String(url).startsWith("https://")) {
      return url;
    }
    return `${URL_BASE_ARCHIVOS}${url}`;
  }, []);

  const esPdf = React.useCallback((archivo) => {
    const tipo = String(archivo?.tipo || "").toLowerCase();
    const nombre = String(archivo?.nombre || archivo?.filename || "").toLowerCase();
    const url = String(archivo?.url || "").toLowerCase();

    return tipo.includes("pdf") || nombre.endsWith(".pdf") || url.includes(".pdf");
  }, []);

  const obtenerIdArchivo = React.useCallback((archivo, movimiento, indice = 0) => {
    return String(
      archivo?.id ||
        archivo?.archivo_id ||
        `${movimiento?.id || "mov"}-${archivo?.url || archivo?.nombre || indice}`
    );
  }, []);

  const imprimeCaratula = async (expediente) => {
    if (!expediente) return;
    await seteaCokieExpediente(expediente);
    window.open("/imprime");
  };

  const imprimeRecibo = async (info) => {
    const esteUsuario = await devuelvemeElUsuario(info.usuarioEntradaID);

    if (esteUsuario) {
      const datosImportantes = {
        usuarioEntradaID: info.usuarioEntradaID,
        destinoEntradaID: info.destinoEntradaID,
        destinoSalidaID: info.destinoSalidaID,
        sedeSalidaID: info.sedeSalidaID,
        sedeEntradaID: info.sedeEntradaID,
        expedienteID: info.expedienteID,
        fechaEntrada: info.fechaEntrada,
        comentario: info.comentario,
        idRecibo: "00-" + info.id,
        fojasActuales: info.fojasActuales,
        usuarioRecibe: esteUsuario,
      };

      seteaCokieReciboExpediente(datosImportantes);
      window.open("/imprimeRecibo");
    }
  };

  const construirTimeline = (listaMovimientos) => {
    if (!Array.isArray(listaMovimientos)) return [];

    const items = [];

    if (props.expediente) {
      items.push({
        id: `caratula-${props.expediente.id || "expediente"}`,
        tipo: "caratula",
        data: props.expediente,
        fecha: props.expediente.fechaGeneracion,
      });
    }

    listaMovimientos.forEach((mov, indiceMovimiento) => {
      items.push({
        id: `movimiento-${mov.id || indiceMovimiento}`,
        tipo: "movimiento",
        data: mov,
        fecha: mov.fechaSalida || mov.fechaEntrada,
      });

      if (Array.isArray(mov.archivos)) {
        mov.archivos.forEach((file, indiceArchivo) => {
          items.push({
            id: `archivo-${obtenerIdArchivo(file, mov, indiceArchivo)}`,
            tipo: "archivo",
            data: file,
            mov,
            fecha: file.fechaCreacion || file.createdAt || mov.fechaEntrada || mov.fechaSalida,
          });
        });
      }
    });

    return items.sort((a, b) => {
      const fechaA = a.fecha ? new Date(a.fecha).getTime() : 0;
      const fechaB = b.fecha ? new Date(b.fecha).getTime() : 0;
      return fechaA - fechaB;
    });
  };

  const abrirModalExpedienteCompleto = async () => {
    if (props.expediente) {
      await seteaCokieExpediente(props.expediente);
    }

    setTimeline(construirTimeline(props.listaMovimientos));
    setModalTimelineOpen(true);
  };

  const abrirModalArchivos = (mov) => {
    setMovimientoSeleccionado(mov);
    setModalOpen(true);
  };

  const timelineFiltrado = React.useMemo(() => {
    return timeline.filter((item) => {
      if (item.tipo !== "movimiento") return true;

      const origen = dependenciasMap[item.data.destinoSalidaID] || "";
      const destino = dependenciasMap[item.data.destinoEntradaID] || "";
      const textoBusqueda = `${origen} ${destino}`.toLowerCase();

      const cumpleDependencia =
        !filtroDependencia || textoBusqueda.includes(filtroDependencia.toLowerCase());

      const fechaMovimiento = item.data.fechaSalida?.slice(0, 10) || "";
      const cumpleFecha = !filtroFecha || fechaMovimiento === filtroFecha;

      return cumpleDependencia && cumpleFecha;
    });
  }, [timeline, filtroDependencia, filtroFecha, dependenciasMap]);

  const todosLosPdfs = React.useMemo(() => {
    if (!Array.isArray(props.listaMovimientos)) return [];

    const resultado = [];

    props.listaMovimientos.forEach((mov, indiceMovimiento) => {
      if (mov?.destinoEntradaID && mov?.fechaEntrada) {
        resultado.push({
          id: obtenerIdRecibo(mov),
          nombre: `recibo-${mov.id || indiceMovimiento}.pdf`,
          tipoSeleccion: "recibo",
          movimiento: mov,
          fecha: mov.fechaEntrada,
        });
      }

      if (!Array.isArray(mov.archivos)) return;

      mov.archivos.forEach((archivo, indiceArchivo) => {
        if (!esPdf(archivo) || !archivo?.url) return;

        resultado.push({
          id: obtenerIdArchivo(archivo, mov, `${indiceMovimiento}-${indiceArchivo}`),
          nombre:
            archivo.nombre ||
            archivo.filename ||
            `documento-${resultado.length + 1}.pdf`,
          url: archivo.url,
          fecha: archivo.fechaCreacion || archivo.createdAt || mov.fechaEntrada || mov.fechaSalida,
          data: archivo,
          movimiento: mov,
          tipoSeleccion: "archivo",
        });
      });
    });

    return resultado;
  }, [props.listaMovimientos, esPdf, obtenerIdArchivo, obtenerIdRecibo]);

  const estaSeleccionado = React.useCallback(
    (archivo, movimiento, indice = 0) => {
      const id = obtenerIdArchivo(archivo, movimiento, indice);
      return pdfsSeleccionados.some((pdf) => pdf.id === id);
    },
    [pdfsSeleccionados, obtenerIdArchivo]
  );

  const obtenerPosicion = React.useCallback(
    (archivo, movimiento, indice = 0) => {
      const id = obtenerIdArchivo(archivo, movimiento, indice);
      const posicion = pdfsSeleccionados.findIndex((pdf) => pdf.id === id);
      return posicion >= 0 ? posicion + 1 : null;
    },
    [pdfsSeleccionados, obtenerIdArchivo]
  );

  const togglePdf = (archivo, movimiento, indice = 0) => {
    if (!esPdf(archivo) || !archivo?.url || uniendoPdfs) return;

    const id = obtenerIdArchivo(archivo, movimiento, indice);

    setPdfsSeleccionados((actuales) => {
      const existe = actuales.some((pdf) => pdf.id === id);

      if (existe) {
        return actuales.filter((pdf) => pdf.id !== id);
      }

      return [
        ...actuales,
        {
          id,
          nombre:
            archivo.nombre ||
            archivo.filename ||
            `documento-${actuales.length + 1}.pdf`,
          url: archivo.url,
          fecha: archivo.fechaCreacion || archivo.createdAt || movimiento?.fechaEntrada || movimiento?.fechaSalida,
          data: archivo,
          movimiento,
        },
      ];
    });
  };

  const estaReciboSeleccionado = React.useCallback(
    (movimiento) => pdfsSeleccionados.some((item) => item.id === obtenerIdRecibo(movimiento)),
    [pdfsSeleccionados, obtenerIdRecibo]
  );

  const toggleRecibo = (movimiento) => {
    if (!movimiento || uniendoPdfs) return;
    const id = obtenerIdRecibo(movimiento);

    setPdfsSeleccionados((actuales) => {
      if (actuales.some((item) => item.id === id)) {
        return actuales.filter((item) => item.id !== id);
      }

      return [
        ...actuales,
        {
          id,
          nombre: `recibo-${movimiento.id || movimiento.expedienteID || actuales.length + 1}.pdf`,
          tipoSeleccion: "recibo",
          movimiento,
          fecha: movimiento.fechaEntrada,
        },
      ];
    });
  };

  const construirDatosRecibo = async (movimiento) => {
    const esteUsuario = await devuelvemeElUsuario(
      movimiento.usuarioEntradaID
    );

    if (!esteUsuario) {
      throw new Error(
        `No se pudo obtener el usuario receptor del recibo 00-${movimiento.id}`
      );
    }

    return {
      usuarioEntradaID: movimiento.usuarioEntradaID,
      destinoEntradaID: movimiento.destinoEntradaID,
      destinoSalidaID: movimiento.destinoSalidaID,
      sedeSalidaID: movimiento.sedeSalidaID,
      sedeEntradaID: movimiento.sedeEntradaID,
      expedienteID: movimiento.expedienteID,
      fechaEntrada: movimiento.fechaEntrada,
      comentario: movimiento.comentario,
      idRecibo: "00-" + movimiento.id,
      fojasActuales: movimiento.fojasActuales,
      usuarioRecibe: esteUsuario,
    };
  };

  const obtenerNombreUsuarioRecibe = (usuario) => {
    if (!usuario) return "";
    if (typeof usuario === "string") return usuario;

    const apellido = usuario.apellido || usuario.Apellido || "";
    const nombre = usuario.nombre || usuario.Nombre || "";
    const nombreCompleto = `${apellido}${apellido && nombre ? ", " : ""}${nombre}`.trim();

    return (
      nombreCompleto ||
      usuario.nombreCompleto ||
      usuario.usuario ||
      usuario.descripcion ||
      ""
    );
  };

  const ReciboPdfTemporal = ({ datos }) => {
    const dependenciaSalida = dependenciasMap[datos.destinoSalidaID] || "-";
    const sedeSalida = sedesMap[datos.sedeSalidaID] || "-";
    const dependenciaEntrada = dependenciasMap[datos.destinoEntradaID] || "-";
    const sedeEntrada = sedesMap[datos.sedeEntradaID] || "-";
    const usuarioRecibe = obtenerNombreUsuarioRecibe(datos.usuarioRecibe);

    const comentario =
      datos.comentario &&
      datos.comentario !== "null" &&
      datos.comentario !== "undefined"
        ? datos.comentario
        : "";

    return (
      <Document
        title={`Recibo expediente ${datos.expedienteID} de fecha: ${regresaBienFechaYHora(
          datos.fechaEntrada
        )}`}
      >
        <Page size="A4" style={{ display: "flex", flexDirection: "column" }}>
          <View
            style={{
              alignSelf: "center",
              height: 35,
              width: 35,
              marginTop: 10,
            }}
          >
            <Image src={Logo} />
          </View>

          <View style={{ marginTop: 35 }}>
            <Text
              style={{
                alignSelf: "center",
                marginTop: -35,
                fontSize: 10,
              }}
            >
              Instituto de Seguridad Pública
            </Text>

            <View
              style={{
                marginLeft: 10,
                marginTop: 65,
                paddingRight: 10,
              }}
            >
              <Text style={{ alignSelf: "flex-start", fontSize: 10 }}>
                ID_Recibo:{datos.idRecibo}
              </Text>

              <Text
                style={{
                  marginTop: 35,
                  marginHorizontal: 5,
                  fontSize: 18,
                  lineHeight: 1.35,
                  textAlign: "left",
                }}
              >
                {`Recibí de ${dependenciaSalida}(${sedeSalida}) expediente identificado en el SEISeP: "${datos.expedienteID}" con el cómputo de (${datos.fojasActuales}) fojas útiles en fecha ${regresaBienFechaYHora(
                  datos.fechaEntrada
                )} horas. Observacion: ${comentario}.-`}
              </Text>

              <Text
                style={{
                  alignSelf: "flex-end",
                  width: 230,
                  marginTop: 12,
                  marginRight: 35,
                  fontSize: 12,
                  textAlign: "center",
                }}
              >
                {usuarioRecibe}
              </Text>

              <Text
                style={{
                  alignSelf: "flex-end",
                  width: 230,
                  marginRight: 35,
                  fontSize: 12,
                  textAlign: "center",
                }}
              >
                {`${dependenciaEntrada}(${sedeEntrada})`}
              </Text>
            </View>

            <Text
              style={{
                alignSelf: "flex-start",
                marginTop: 12,
                fontSize: 18,
              }}
            >
              ------------------------------------------------------------------------------------------------------------------
            </Text>
          </View>
        </Page>
      </Document>
    );
  };

  /*
   * Genera el recibo con el mismo motor y estilo del componente Recibo:
   * @react-pdf/renderer, A4, escudo, encabezado y cuerpo original.
   */
  const generarPdfReciboReal = async (movimiento) => {
    const datosRecibo = await construirDatosRecibo(movimiento);

    const instanciaPdf = pdf(
      <ReciboPdfTemporal datos={datosRecibo} />
    );

    const blob = await instanciaPdf.toBlob();

    if (!blob || blob.size === 0) {
      throw new Error(
        `No se pudo generar el recibo 00-${movimiento.id}.`
      );
    }

    return blob;
  };

  const seleccionarTodosLosPdfs = () => {
//     console.log("Toque boton seleccionar PDF")
    if (uniendoPdfs) return;
    setPdfsSeleccionados(todosLosPdfs);
  };

  const limpiarSeleccion = () => {
    if (uniendoPdfs) return;
    setPdfsSeleccionados([]);
  };

  const quitarPdf = (id) => {
    if (uniendoPdfs) return;
    setPdfsSeleccionados((actuales) => actuales.filter((pdf) => pdf.id !== id));
  };

  const moverPdf = (indiceActual, indiceNuevo) => {
    if (uniendoPdfs) return;

    setPdfsSeleccionados((actuales) => {
      if (indiceNuevo < 0 || indiceNuevo >= actuales.length) return actuales;

      const copia = [...actuales];
      const [movido] = copia.splice(indiceActual, 1);
      copia.splice(indiceNuevo, 0, movido);
      return copia;
    });
  };

  /*
   * Envía al backend:
   * - Los recibos generados localmente como archivos multipart.
   * - Las URL de los PDF adjuntos para que el BACKEND los descargue.
   * - El orden exacto seleccionado por el usuario.
   *
   * Esto evita CORS, porque el navegador nunca intenta leer los PDF de wwwa.
   */
  const unirPdfsSeleccionados = async () => {
    if (pdfsSeleccionados.length < 2) {
      Swal.fire(
        "Seleccioná más documentos",
        "Debés seleccionar al menos dos PDF o recibos para unir.",
        "warning"
      );
      return;
    }

    const confirmacion = await Swal.fire({
      title: "¿Generar PDF único?",
      html: `
        <div style="text-align:left">
          <p>Se unirán <b>${pdfsSeleccionados.length} documentos</b> en este orden:</p>
          <ol style="padding-left:22px">
            ${pdfsSeleccionados
              .map(
                (item) =>
                  `<li style="margin-bottom:5px">${item.nombre}</li>`
              )
              .join("")}
          </ol>
        </div>
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Unir y descargar",
      cancelButtonText: "Cancelar",
    });

    if (!confirmacion.isConfirmed) return;

    setUniendoPdfs(true);

    Swal.fire({
      title: "Generando PDF",
      text: "Preparando recibos y enviando documentos al servidor...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading(),
    });

try {
  const formData = new FormData();

  for (let i = 0; i < pdfsSeleccionados.length; i += 1) {
    const seleccionado = pdfsSeleccionados[i];

    if (seleccionado.tipoSeleccion === "recibo") {
      const blobRecibo = await generarPdfReciboReal(
        seleccionado.movimiento
      );

      formData.append(
        "files",
        blobRecibo,
        seleccionado.nombre || `recibo-${i + 1}.pdf`
      );
    } else {
      const urlCompleta = obtenerUrlCompleta(seleccionado.url);

      if (!urlCompleta) {
        throw new Error(
          `El archivo ${seleccionado.nombre} no tiene una URL válida.`
        );
      }

      const respuestaPdf = await fetch(urlCompleta);

      if (!respuestaPdf.ok) {
        throw new Error(
          `No se pudo descargar el archivo ${seleccionado.nombre}.`
        );
      }

      const blobPdf = await respuestaPdf.blob();

      formData.append(
        "files",
        blobPdf,
        seleccionado.nombre || `documento-${i + 1}.pdf`
      );
    }
  }

  const respuesta = await fetch(URL_UNIR_PDFS, {
    method: "POST",
    body: formData,
    credentials: "include",
  });

  if (!respuesta.ok) {
    let mensaje = "No se pudieron unir los documentos.";

    try {
      const contentType =
        respuesta.headers.get("content-type") || "";

      if (contentType.includes("application/json")) {
        const errorJson = await respuesta.json();
        mensaje =
          errorJson?.error ||
          errorJson?.message ||
          mensaje;
      } else {
        const texto = await respuesta.text();
        if (texto) mensaje = texto;
      }
    } catch (errorLectura) {
      console.error(
        "No se pudo leer el error del servidor:",
        errorLectura
      );
    }

    throw new Error(mensaje);
  }

  const blobFinal = await respuesta.blob();

  if (!blobFinal || blobFinal.size === 0) {
    throw new Error("El servidor devolvió un PDF vacío.");
  }

  const urlDescarga =
    window.URL.createObjectURL(blobFinal);

  const link = document.createElement("a");

  const expedienteId =
    props.expediente?.id ||
    props.expediente?.expedienteID ||
    "expediente";

  link.href = urlDescarga;
  link.download = `expediente-${expedienteId}-completo.pdf`;
  link.style.display = "none";

  document.body.appendChild(link);
  link.click();
  link.remove();

  setTimeout(() => {
    window.URL.revokeObjectURL(urlDescarga);
  }, 3000);

  const totalPaginas =
    respuesta.headers.get("x-total-pages");

  await Swal.fire({
    title: "PDF generado",
    html: `
      <p>Documentos unidos: <b>${pdfsSeleccionados.length}</b></p>
      ${
        totalPaginas
          ? `<p>Total de páginas: <b>${totalPaginas}</b></p>`
          : ""
      }
    `,
    icon: "success",
  });
} catch (error) {
      console.error("Error al unir los documentos:", error);

      Swal.fire(
        "Error",
        error?.message ||
          "No se pudo generar el PDF completo.",
        "error"
      );
    } finally {
      setUniendoPdfs(false);
    }
  };

  const barraSeleccionPdfs = (
    <div
      style={{
        background: "#fff",
        border: "1px solid #dbeafe",
        borderRadius: "14px",
        padding: "12px",
        marginBottom: "15px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        <div>
          <strong>Documentos seleccionados: {pdfsSeleccionados.length}</strong>
          <div style={{ color: "#64748b", fontSize: "12px", marginTop: "3px" }}>
            Los adjuntos se descargan desde el backend y los recibos se generan localmente.
          </div>
        </div>

        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
          <button
            type="button"
            onClick={seleccionarTodosLosPdfs}
            //disabled={uniendoPdfs || todosLosPdfs.length === 0}
            style={{
              background: "#eff6ff",
              color: "#1d4ed8",
              border: "1px solid #93c5fd",
              padding: "9px 12px",
              borderRadius: "9px",
              cursor: uniendoPdfs ? "not-allowed" : "pointer",
            }}
          >
            Seleccionar todos
          </button>

          <button
            type="button"
            onClick={limpiarSeleccion}
            disabled={uniendoPdfs || pdfsSeleccionados.length === 0}
            style={{
              background: "#f8fafc",
              color: "#334155",
              border: "1px solid #cbd5e1",
              padding: "9px 12px",
              borderRadius: "9px",
              cursor: uniendoPdfs ? "not-allowed" : "pointer",
            }}
          >
            Limpiar
          </button>

          <button
            type="button"
            onClick={unirPdfsSeleccionados}
            //disabled={uniendoPdfs || pdfsSeleccionados.length === 0}
            style={{
              background: pdfsSeleccionados.length > 0 ? "#16a34a" : "#94a3b8",
              color: "#fff",
              border: "none",
              padding: "9px 14px",
              borderRadius: "9px",
              fontWeight: "700",
              cursor:
                uniendoPdfs || pdfsSeleccionados.length === 0 ? "not-allowed" : "pointer",
            }}
          >
            {uniendoPdfs ? "UNIENDO..." : "UNIR Y DESCARGAR PDF"}
          </button>
        </div>
      </div>

      {pdfsSeleccionados.length > 0 && (
        <div style={{ marginTop: "12px", borderTop: "1px solid #dbeafe" }}>
          {pdfsSeleccionados.map((pdf, indice) => (
            <div
              key={pdf.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "8px 4px",
                borderBottom: "1px solid #eef2ff",
              }}
            >
              <span
                style={{
                  width: "26px",
                  height: "26px",
                  borderRadius: "50%",
                  background: "#2563eb",
                  color: "#fff",
                  display: "inline-flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "12px",
                  fontWeight: "700",
                  flexShrink: 0,
                }}
              >
                {indice + 1}
              </span>

              <span style={{ flex: 1, minWidth: 0, wordBreak: "break-word" }}>
                📄 {pdf.nombre}
              </span>

              <button
                type="button"
                disabled={indice === 0 || uniendoPdfs}
                onClick={() => moverPdf(indice, indice - 1)}
                title="Subir"
                style={{ border: "none", background: "transparent", cursor: "pointer" }}
              >
                ↑
              </button>

              <button
                type="button"
                disabled={indice === pdfsSeleccionados.length - 1 || uniendoPdfs}
                onClick={() => moverPdf(indice, indice + 1)}
                title="Bajar"
                style={{ border: "none", background: "transparent", cursor: "pointer" }}
              >
                ↓
              </button>

              <button
                type="button"
                disabled={uniendoPdfs}
                onClick={() => quitarPdf(pdf.id)}
                title="Quitar"
                style={{
                  border: "none",
                  background: "transparent",
                  color: "#dc2626",
                  cursor: "pointer",
                }}
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  const renderSelectorPdf = (archivo, movimiento, indice = 0) => {
    if (!esPdf(archivo) || !archivo?.url) return null;

    const seleccionado = estaSeleccionado(archivo, movimiento, indice);
    const posicion = obtenerPosicion(archivo, movimiento, indice);

    return (
      <label
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "7px",
          background: seleccionado ? "#2563eb" : "#f1f5f9",
          color: seleccionado ? "#fff" : "#0f172a",
          borderRadius: "9px",
          padding: "7px 10px",
          cursor: uniendoPdfs ? "not-allowed" : "pointer",
          fontSize: "12px",
          fontWeight: "700",
        }}
      >
        <input
          type="checkbox"
          checked={seleccionado}
          disabled={uniendoPdfs}
          onChange={() => togglePdf(archivo, movimiento, indice)}
          style={{ width: "17px", height: "17px" }}
        />
        {seleccionado ? `Orden ${posicion}` : "Seleccionar PDF"}
      </label>
    );
  };

  return (
    <div>
      <button
        onClick={abrirModalExpedienteCompleto}
        style={{
          background: "#0f172a",
          color: "#fff",
          border: "none",
          padding: "10px 16px",
          borderRadius: "10px",
          cursor: "pointer",
          fontWeight: "600",
          marginBottom: "15px",
        }}
      >
        📜 Ver historia completa
      </button>
{comprueboPermisos(Usuario.funcion, "Descargo Expedientes") && barraSeleccionPdfs}

      <Table className="table-primary" bordered responsive size="sm">
        <thead>
          <tr style={{ backgroundColor: "#475569", color: "#fff" }}>
            <th>#</th>
            <th>Proveniente</th>
            <th>Fecha salida</th>
            <th>Comentario salida</th>
            <th>Comentario recepción</th>
            <th>Fojas</th>
            <th>Destino</th>
            <th>Fecha recepción</th>
            <th>Recibo</th>
            <th>📎</th>
          </tr>
        </thead>

        <tbody>
          {!Array.isArray(props.listaMovimientos)
            ? null
            : props.listaMovimientos.map((cosas, indice) => {
                const origen = dependenciasMap[cosas.destinoSalidaID] || "-";
                const sedeOrigen = sedesMap[cosas.sedeSalidaID] || "-";
                const destino = dependenciasMap[cosas.destinoEntradaID] || "-";
                const sedeDestino = sedesMap[cosas.sedeEntradaID] || "-";

                return (
                  <tr key={cosas.id || indice}>
                    <th>{indice + 1}</th>
                    <td>{origen} ({sedeOrigen})</td>
                    <td>{regresaBienFechaYHora(cosas.fechaSalida)}</td>
                    <td>{cosas.comentarioSalida}</td>
                    <td>{cosas.comentario}</td>
                    <td>{cosas.fojasActuales}</td>
                    <td>
                      {cosas.destinoEntradaID
                        ? `${destino} (${sedeDestino})`
                        : cosas.esArchivo
                        ? cosas.esArchivo
                        : "En tránsito"}
                    </td>
                    <td>{regresaBienFechaYHora(cosas.fechaEntrada)}</td>
                    <td>
                      {cosas.destinoEntradaID && cosas.fechaEntrada ? (
                        <div style={{ display: "flex", gap: "6px", alignItems: "center", flexWrap: "wrap" }}>
                          <label style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "12px", fontWeight: "700" }}>
                            <input
                              type="checkbox"
                              checked={estaReciboSeleccionado(cosas)}
                              onChange={() => toggleRecibo(cosas)}
                            />
                            Unir
                          </label>
                          <button
                          onClick={() => imprimeRecibo(cosas)}
                          style={{
                            background: "#0f172a",
                            color: "#fff",
                            border: "none",
                            padding: "6px 10px",
                            borderRadius: "8px",
                            cursor: "pointer",
                          }}
                        >
                          Ver
                        </button>
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      {cosas.archivos?.length > 0 ? (
                        <span
                          onClick={() => abrirModalArchivos(cosas)}
                          style={{
                            background: "#2563eb",
                            color: "#fff",
                            padding: "5px 10px",
                            borderRadius: "999px",
                            fontSize: "12px",
                            cursor: "pointer",
                            fontWeight: "600",
                          }}
                        >
                          📎 {cosas.archivos.length}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                );
              })}
        </tbody>
      </Table>

      {/* MODAL ARCHIVOS */}
      <Modal
        isOpen={modalOpen}
        onRequestClose={() => !uniendoPdfs && setModalOpen(false)}
        ariaHideApp={false}
        style={{
          overlay: { backgroundColor: "rgba(0,0,0,0.45)", zIndex: 999 },
          content: {
            maxWidth: "900px",
            width: "95%",
            margin: "auto",
            height: "90vh",
            borderRadius: "18px",
            border: "none",
            padding: "20px",
            overflowY: "auto",
          },
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h3 style={{ margin: 0 }}>📎 Archivos del movimiento</h3>
          <button
            onClick={() => setModalOpen(false)}
            disabled={uniendoPdfs}
            style={{
              background: "#ef4444",
              color: "#fff",
              border: "none",
              padding: "8px 12px",
              borderRadius: "10px",
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>

       

        {!movimientoSeleccionado ? (
          <p>No hay datos</p>
        ) : (
          movimientoSeleccionado.archivos?.map((file, indice) => {
            const url = obtenerUrlCompleta(file.url);
            const tipo = file.tipo || "";
            const nombre = file.nombre || file.filename || "Archivo";
            const seleccionado = estaSeleccionado(file, movimientoSeleccionado, indice);

            return (
              <div
                key={obtenerIdArchivo(file, movimientoSeleccionado, indice)}
                style={{
                  marginBottom: "20px",
                  padding: "15px",
                  borderRadius: "14px",
                  border: seleccionado ? "2px solid #2563eb" : "1px solid #e2e8f0",
                  background: seleccionado ? "#eff6ff" : "#fff",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px",
                    flexWrap: "wrap",
                    marginBottom: "10px",
                  }}
                >
                  <strong style={{ wordBreak: "break-word" }}>{nombre}</strong>
                  {renderSelectorPdf(file, movimientoSeleccionado, indice)}
                </div>

                {esPdf(file) ? (
                  <embed
                    src={url}
                    type="application/pdf"
                    width="100%"
                    height="450px"
                    style={{ border: "1px solid #ccc", borderRadius: "12px" }}
                  />
                ) : tipo.startsWith("image/") ? (
                  <img
                    src={url}
                    alt={nombre}
                    style={{ maxWidth: "100%", borderRadius: "12px", border: "1px solid #ccc" }}
                  />
                ) : (
                  <a href={url} target="_blank" rel="noreferrer">
                    📥 Descargar archivo
                  </a>
                )}
              </div>
            );
          })
        )}
      </Modal>

      {/* MODAL TIMELINE */}
      <Modal
        isOpen={modalTimelineOpen}
        onRequestClose={() => !uniendoPdfs && setModalTimelineOpen(false)}
        ariaHideApp={false}
        style={{
          overlay: { backgroundColor: "rgba(0,0,0,0.45)", zIndex: 999 },
          content: {
            maxWidth: "950px",
            width: "95%",
            margin: "auto",
            height: "92vh",
            inset: "20px",
            border: "none",
            borderRadius: "18px",
            padding: "0px",
            overflow: "hidden",
            background: "#f4f7fb",
            boxShadow: "0 10px 35px rgba(0,0,0,0.18)",
          },
        }}
      >
        <div
          style={{
            padding: "18px 22px",
            borderBottom: "1px solid #e0e0e0",
            background: "#fff",
            position: "sticky",
            top: 0,
            zIndex: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <div>
              <h2 style={{ margin: 0, fontSize: "22px", color: "#1e293b" }}>
                📜 Historia del Expediente
              </h2>
              <span style={{ fontSize: "13px", color: "#64748b" }}>
                Línea de tiempo completa
              </span>
            </div>

            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <button
                onClick={() => setMostrarPreview(!mostrarPreview)}
                style={{
                  background: mostrarPreview ? "#ef4444" : "#22c55e",
                  color: "#fff",
                  border: "none",
                  padding: "10px 14px",
                  borderRadius: "10px",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                {mostrarPreview ? "Ocultar vistas" : "Mostrar vistas"}
              </button>

              <button
                onClick={() => setModalTimelineOpen(false)}
                disabled={uniendoPdfs}
                style={{
                  background: "#e2e8f0",
                  border: "none",
                  padding: "10px 14px",
                  borderRadius: "10px",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                ✕
              </button>
            </div>
          </div>

          <div
            style={{
              marginTop: "15px",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
              gap: "12px",
            }}
          >
            <input
              type="text"
              placeholder="🔎 Buscar dependencia..."
              value={filtroDependencia}
              onChange={(e) => setFiltroDependencia(e.target.value)}
              style={{
                padding: "12px",
                borderRadius: "10px",
                border: "1px solid #dbe2ea",
                outline: "none",
                fontSize: "14px",
              }}
            />

            <input
              type="date"
              value={filtroFecha}
              onChange={(e) => setFiltroFecha(e.target.value)}
              style={{
                padding: "12px",
                borderRadius: "10px",
                border: "1px solid #dbe2ea",
                outline: "none",
                fontSize: "14px",
              }}
            />

            <button
              onClick={() => {
                setFiltroDependencia("");
                setFiltroFecha("");
              }}
              style={{
                background: "#0f172a",
                color: "#fff",
                border: "none",
                padding: "12px",
                borderRadius: "10px",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              Limpiar filtros
            </button>
          </div>
        </div>

        <div style={{ padding: "20px", overflowY: "auto", height: "calc(92vh - 180px)" }}>
{comprueboPermisos(Usuario.funcion, "Descargo Expedientes") && barraSeleccionPdfs}

          {timelineFiltrado.map((item, i) => {
            if (item.tipo === "caratula") {
              return (
                <div
                  key={item.id || i}
                  style={{
                    background: "#fff",
                    borderRadius: "18px",
                    padding: "18px",
                    marginBottom: "18px",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                  }}
                >
                  <h4>📘 Carátula del expediente</h4>
                  <button
                    type="button"
                    onClick={() => imprimeCaratula(item.data)}
                    style={{
                      marginBottom: "10px",
                      background: "#0f172a",
                      color: "#fff",
                      border: "none",
                      padding: "8px 12px",
                      borderRadius: "8px",
                    }}
                  >
                    Abrir carátula
                  </button>

                  {mostrarPreview && (
                    <iframe
                      src="/imprime"
                      title="Caratula"
                      width="100%"
                      height="650px"
                      style={{ border: "1px solid #e2e8f0", borderRadius: "12px" }}
                    />
                  )}
                </div>
              );
            }

            if (item.tipo === "movimiento") {
              const origen = dependenciasMap[item.data.destinoSalidaID] || "-";
              const sedeOrigen = sedesMap[item.data.sedeSalidaID] || "-";
              const destino = dependenciasMap[item.data.destinoEntradaID] || "-";
              const sedeDestino = sedesMap[item.data.sedeEntradaID] || "-";

              if (!mostrarPreview) {
                return (
                  <div
                    key={item.id || i}
                    style={{
                      background: "#fff",
                      borderRadius: "14px",
                      padding: "14px 16px",
                      marginBottom: "10px",
                      border: "1px solid #e2e8f0",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "12px",
                      flexWrap: "wrap",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column", gap: "5px", flex: 1 }}>
                      <span style={{ fontSize: "12px", color: "#64748b" }}>
                        {regresaBienFechaYHora(item.data.fechaSalida)}
                      </span>
                      <strong>{origen}</strong>
                      <span style={{ color: "#64748b", fontSize: "13px" }}>
                        → {item.data.destinoEntradaID ? destino : "En tránsito"}
                      </span>
                      {item.data.fechaEntrada && (
                        <span style={{ fontSize: "12px", color: "#16a34a", fontWeight: "600" }}>
                          ✓ Recepcionado
                        </span>
                      )}
                    </div>

                    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                      {item.data.archivos?.length > 0 && (
                        <span
                          onClick={() => abrirModalArchivos(item.data)}
                          style={{
                            background: "#2563eb",
                            color: "#fff",
                            padding: "7px 10px",
                            borderRadius: "999px",
                            fontSize: "12px",
                            cursor: "pointer",
                            fontWeight: "600",
                          }}
                        >
                          📎 {item.data.archivos.length}
                        </span>
                      )}

                      {item.data.destinoEntradaID && item.data.fechaEntrada && (
                        <>
                        <label style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "12px", fontWeight: "700" }}>
                          <input type="checkbox" checked={estaReciboSeleccionado(item.data)} onChange={() => toggleRecibo(item.data)} />
                          Recibo
                        </label>
                        <button
                          onClick={() => imprimeRecibo(item.data)}
                          style={{
                            background: "#0f172a",
                            color: "#fff",
                            border: "none",
                            padding: "8px 12px",
                            borderRadius: "8px",
                          }}
                        >
                          Ver recibo
                        </button>
                        </>
                      )}
                    </div>
                  </div>
                );
              }

              return (
                <div
                  key={item.id || i}
                  style={{
                    background: "#fff",
                    borderRadius: "18px",
                    padding: "18px",
                    marginBottom: "18px",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                    <h4>📦 Movimiento</h4>
                    <span
                      style={{
                        background: "#eff6ff",
                        color: "#2563eb",
                        padding: "6px 10px",
                        borderRadius: "999px",
                        fontSize: "12px",
                      }}
                    >
                      {regresaBienFechaYHora(item.data.fechaSalida)}
                    </span>
                  </div>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
                      gap: "14px",
                    }}
                  >
                    <div>
                      <span style={{ fontSize: "12px", color: "#64748b" }}>ORIGEN</span>
                      <p><strong>{origen}</strong></p>
                      <span>{sedeOrigen}</span>
                    </div>

                    <div>
                      <span style={{ fontSize: "12px", color: "#64748b" }}>DESTINO</span>
                      <p><strong>{item.data.destinoEntradaID ? destino : "En tránsito"}</strong></p>
                      <span>{item.data.destinoEntradaID ? sedeDestino : ""}</span>
                    </div>

                    <div>
                      <span style={{ fontSize: "12px", color: "#64748b" }}>FOJAS</span>
                      <p><strong>{item.data.fojasActuales}</strong></p>
                    </div>
                  </div>

                  {(item.data.comentarioSalida || item.data.comentario) && (
                    <div
                      style={{
                        marginTop: "18px",
                        background: "#f8fafc",
                        borderRadius: "12px",
                        padding: "14px",
                      }}
                    >
                      {item.data.comentarioSalida && (
                        <p><strong>Salida:</strong> {item.data.comentarioSalida}</p>
                      )}
                      {item.data.comentario && (
                        <p><strong>Recepción:</strong> {item.data.comentario}</p>
                      )}
                    </div>
                  )}

                  {item.data.destinoEntradaID && item.data.fechaEntrada && (
                    <div
                      style={{
                        marginTop: "18px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        background: "#f1f5f9",
                        borderRadius: "12px",
                        padding: "14px",
                      }}
                    >
                      <div>
                        <strong>🧾 Recibo generado</strong>
                        <div style={{ fontSize: "13px", color: "#64748b", marginTop: "4px" }}>
                          Recepcionado el {regresaBienFechaYHora(item.data.fechaEntrada)}
                        </div>
                      </div>

                      <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
                        <label style={{ display: "flex", alignItems: "center", gap: "6px", fontWeight: "700", color: estaReciboSeleccionado(item.data) ? "#1d4ed8" : "#334155" }}>
                          <input
                            type="checkbox"
                            checked={estaReciboSeleccionado(item.data)}
                            onChange={() => toggleRecibo(item.data)}
                          />
                          {estaReciboSeleccionado(item.data) ? "Recibo seleccionado" : "Seleccionar recibo"}
                        </label>
                        <button
                        onClick={() => imprimeRecibo(item.data)}
                        style={{
                          background: "#0f172a",
                          color: "#fff",
                          border: "none",
                          padding: "10px 14px",
                          borderRadius: "10px",
                          cursor: "pointer",
                          fontWeight: "600",
                        }}
                      >
                        Ver recibo
                      </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            }

            if (item.tipo === "archivo") {
              const url = obtenerUrlCompleta(item.data.url);
              const seleccionado = estaSeleccionado(item.data, item.mov, i);

              return (
                <div
                  key={item.id || i}
                  style={{
                    background: seleccionado ? "#eff6ff" : "#fff",
                    borderRadius: "18px",
                    padding: "18px",
                    marginBottom: "18px",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                    border: seleccionado ? "2px solid #2563eb" : "1px solid transparent",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "10px",
                      flexWrap: "wrap",
                      marginBottom: "12px",
                    }}
                  >
                    <div>
                      <h4 style={{ margin: 0 }}>📎 Archivo adjunto</h4>
                      <div style={{ marginTop: "5px", wordBreak: "break-word" }}>
                        {item.data.nombre || item.data.filename || "Archivo"}
                      </div>
                    </div>

                    {renderSelectorPdf(item.data, item.mov, i)}
                  </div>

                  {item.data.tipo?.startsWith("image/") &&
                    (mostrarPreview ? (
                      <img
                        src={url}
                        alt={item.data.nombre || "Archivo"}
                        style={{ maxWidth: "100%", borderRadius: "12px" }}
                      />
                    ) : (
                      <a href={url} target="_blank" rel="noreferrer">Ver imagen</a>
                    ))}

                  {esPdf(item.data) &&
                    (mostrarPreview ? (
                      <embed src={url} type="application/pdf" width="100%" height="500px" style={{ borderRadius: "12px" }} />
                    ) : (
                      <a href={url} target="_blank" rel="noreferrer">Ver PDF</a>
                    ))}

                  {!item.data.tipo?.startsWith("image/") && !esPdf(item.data) && (
                    <a href={url} target="_blank" rel="noreferrer">Descargar archivo</a>
                  )}
                </div>
              );
            }

            return null;
          })}
        </div>
      </Modal>
    </div>
  );
}

export default ModuloDevuelveListaMov;